import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            追剧常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于琪琪影院，你想知道的都在这里</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.question}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-semibold text-foreground-800 hover:text-primary-500 transition-colors list-none">
                <span>{item.question}</span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 group-open:text-primary-500 transition-colors flex-shrink-0 ml-3">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform" />
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}